/**
 * Names the avatar demo cycles through. Anything that needs a caveat is not on the list, and
 * nothing here is a real Gryt user. `avatarSeed` lower-cases, so case does not matter.
 */
export const DEMO_NAMES = [
  // Ordinary, and the ones already in the client screenshots
  "astrid",
  "bjørn",
  "dagny",
  "eirik",
  "freya",
  "guro",
  "håkon",
  "sindre",
  "sigrid",
  "øystein",
  "emma",
  "noah",
  "olivia",
  "liam",
  "sofia",
  "mateo",
  "yuki",
  "aisha",
  "chen",
  "priya",

  // The ones whose voice you heard through a headset for most of a decade
  "pewdiepie",
  "markiplier",
  "jacksepticeye",
  "vanossgaming",
  "captainsparklez",
  "smosh",
  "tobuscus",
  "dantdm",
  "stampylonghead",
  "yogscast",
  "game grumps",
  "achievement hunter",
  "rhett and link",
  "vsauce",
  "casey neistat",
  "lilly singh",
  "ijustine",
  "rosanna pansino",
  "lindsey stirling",
  "daithi de nogla",

  // Old internet
  "megatron",
  "doge",
  "leeroy jenkins",
  "chuck norris",
  "rick astley",
  "keyboard cat",
  "grumpy cat",
  "nyan cat",
  "trollface",
  "success kid",
  "this is fine",
  "stonks",
  "shrek",
  "john cena",
  "gordon freeman",
  "hatsune miku",
  "philosoraptor",
  "dat boi",
  "big chungus",
  "all your base",
];
